import type { FC, ReactNode } from 'react'

import { StageNav } from '@/components/generals/stage-nav'
import { StageFooter } from '@/components/generals/stage-footer'

interface StagePageProps {
    /** The path of the current page, handed to the nav so it can mark itself. */
    active?: string
    children: ReactNode
}

/* The same stage the heart comes out of: near-black ground, warm off-white ink,
 * and the blue the detail card uses for its verified mark carried over as the
 * one accent and the focus colour. */
export const StagePage: FC<StagePageProps> = ({ active, children }): ReactNode => {
    return (
        <div className='flex min-h-dvh flex-col bg-[#050506] text-[#F4F1EA] selection:bg-[#4EA3FF]/30 selection:text-white'>
            <StageNav active={active} />

            <main className='flex-1'>
                {children}
            </main>

            <StageFooter />
        </div>
    )
}
